import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { UppdragPage } from "pages/app/uppdrag/UppdragPage";
import { getUppdrag } from "api/uppdrag.api";

const uppdragSearchSchema = z.object({
  tab: z
    .enum(["oversikt", "transport-sedel", "bilagor", "naturvardsverket"])
    .optional()
    .catch("oversikt"),
});

export const Route = createFileRoute("/_authenticated/app/uppdrag/$uuid/")({
  validateSearch: uppdragSearchSchema,
  beforeLoad: async ({ context: { queryClient }, params }) => {
    await queryClient.ensureQueryData(getUppdrag(params.uuid));
  },
  component: UppdragPage,
});
